import { useMemo } from 'react';
import type { BrowserCapabilities } from '../types.js';

const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

export function useBrowserCapabilities(): BrowserCapabilities {
  return useMemo(() => {
    if (!isBrowser) {
      return {
        canPlayHLS: false,
        supportsMSE: false,
        canPlayWebM: false,
        canPlayAV1: false,
        hasHardwareAcceleration: false,
      };
    }

    const video = document.createElement('video');
    const canPlayType = (type: string) => video.canPlayType(type) !== '';

    const capabilities: BrowserCapabilities = {
      canPlayHLS: canPlayType('application/vnd.apple.mpegurl'),
      supportsMSE: typeof (window as any).MediaSource !== 'undefined',
      canPlayWebM: canPlayType('video/webm; codecs=vp9') || canPlayType('video/webm; codecs=vp8'),
      canPlayAV1: canPlayType('video/mp4; codecs=av01.0.05M.08') || canPlayType('video/av1'),
      hasHardwareAcceleration: canPlayType('video/mp4; codecs=avc1.42E01E'),
    };

    return capabilities;
  }, []);
}
